import { AdminListView } from "./AdminListView";
import { journeyAdapter } from "./journeyAdapter";

export function JourneyAdminPage() {
  return <AdminListView adapter={journeyAdapter} />;
}
